<template>
  <validation-observer
    ref="observer"
    v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(onSubmit)">
      <div
        v-for="(contact, index) in form.contacts"
        :key="index"
        class="d-flex align-items-center mb-2"
        style="gap: 8px;">
        <span>{{ index + 1 | circledNumber }}</span>
        <div
          class="flex-grow-1"
          style="max-width: 100px;">
          <label
            class="fs-m font-weight-bold"
            :for="`emergency_contact_relationship_${index}`">
            続柄
          </label>
          <BaseSelectWithProvider
            v-model="form.contacts[index].relationship"
            :name="`emergency_contact_relationship_${index}`"
            :options="emergencyContactRelationshipOptions" />
        </div>
        <div class="flex-grow-1">
          <label
            class="fs-m font-weight-bold"
            :for="`emergency_contact_phonenumber_${index}`">
            電話番号
          </label>
          <BaseTextFieldWithProvider
            v-if="form.contacts[index].relationship !== null"
            v-model="form.contacts[index].phoneNumber"
            name="電話番号"
            :vid="`emergency_contact_phonenumber_${index}`"
            :rules="`required|phonenumber|${getUniquePhoneNumbersRules(index)}`"
            placeholder="電話番号"
            empty-str-to-null />
          <BaseTextFieldWithProvider
            v-else
            :name="`emergency_contact_phonenumber_${index}`"
            disabled
            placeholder="電話番号" />
        </div>
      </div>
      <hr class="my-4">
      <div
        class="d-flex align-items-start mb-2"
        style="gap: 8px;">
        <label
          class="fs-m font-weight-bold pl-4 pt-6"
          style="width: 124px; min-width: 124px;">
          自分の連絡先
        </label>
        <div class="flex-grow-1">
          <label
            class="fs-m font-weight-bold"
            :for="`emergency_contact_phonenumber_self`">
            電話番号
          </label>
          <BaseTextFieldWithProvider
            v-model="form.selfContact.phoneNumber"
            name="電話番号"
            :vid="`emergency_contact_phonenumber_self`"
            :rules="`phonenumber|${getUniquePhoneNumbersRules(3)}`"
            placeholder="電話番号"
            empty-str-to-null />
        </div>
      </div>
      <div
        class="d-flex justify-content-between mt-4"
        style="gap: 16px;">
        <button
          type="button"
          class="btn btn-block btn-cancel"
          @click="onClickCancel">
          キャンセル
        </button>
        <button
          type="submit"
          class="btn btn-block btn-primary mt-0">
          保存
        </button>
      </div>
    </form>
  </validation-observer>
</template>

<script>

import BaseSelectWithProvider from '@/components/parts/BaseSelectWithProvider.vue'
import BaseTextFieldWithProvider from '@/components/parts/BaseTextFieldWithProvider.vue'
import { relationshipOptions } from '@/utils/relationship'

export default {
  components: {
    BaseSelectWithProvider,
    BaseTextFieldWithProvider
  },
  props: {
    emergencyContacts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        contacts: [
          {
            relationship: null,
            phoneNumber: null,
          },
          {
            relationship: null,
            phoneNumber: null,
          },
          {
            relationship: null,
            phoneNumber: null,
          },
        ],
        selfContact: {
          relationship: 'self',
          phoneNumber: null
        }
      }
    }
  },
  computed: {
    emergencyContactRelationshipOptions() {
      return relationshipOptions
    }
  },
  created() {
    this.setEmergencyContacts()
  },
  methods: {
    onSubmit() {
      const contacts = [
        ...this.form.contacts.filter(contact => contact.relationship !== null),
        ...this.form.selfContact.phoneNumber !== null ? [{
          relationship: 'self',
          phoneNumber: this.form.selfContact.phoneNumber
        }] : []
      ]
      console.warn(contacts)
      this.$emit('submit', { contacts })
    },
    setEmergencyContacts() {
      if (this.emergencyContacts.length > 0) {
        const [emergencyContactsWithoutSelf, emergencyContactSelf] = this.emergencyContacts.reduce((acc, contact) => {
          if (contact.relationship === 'self') {
            acc[1] = contact
          } else {
            acc[0].push(contact)
          }
          return acc
        }, [[], null])
        this.form.contacts = this.form.contacts.map((contact, index) => {
          const emergencyContact = emergencyContactsWithoutSelf[index]
          if (!emergencyContact) {
            return contact
          }
          return {
            ...contact,
            relationship: emergencyContact.relationship,
            phoneNumber: emergencyContact.phoneNumber
          }
        })
        this.form.selfContact.phoneNumber = emergencyContactSelf?.phoneNumber || null
      }
    },
    getUniquePhoneNumbersRules(index) {
      const otherPhoneNumbers = [...this.form.contacts, this.form.selfContact]
        .map((contact, idx) => idx !== index ? contact.phoneNumber : null)
        .filter(num => num !== null && num !== undefined)
      return `phone_number_unique:${otherPhoneNumbers}`
    },
    onClickCancel() {
      this.$router.back()
    }
  }
}
</script>

<style>

</style>